/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-09-23 20:07:23
 * @FilePath: \senlan-ai-ui\src\pages\ChatPage\components\ChatLandingView\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PlaceholderNode } from '../../../../const'
import { useStyle } from '../../style'
import { MenuPage } from '../../../../stores/functionMenu.store'
import { useConversationContext } from '../../../../stores/conversation.store'

import BasePage from '../../../components/BasePage'
import ChatInput from '../input'
import ModelSelect from '../../../components/ModelSelect'
const ChatLandingView = () => {
  const { styles } = useStyle()
  const navigate = useNavigate()
  const [inputValue, setInputValue] = useState<string>('')
  const [isLoading, setIsLoading] = useState(false)
  const { createConversation } = useConversationContext()

  const handlePromptClick = (info: {
    data: { key: string; description: string; category: number; extConfig: any }
  }) => {
    if (info.data.category == 2) setInputValue(info.data.description)
    else
      navigate(
        `/rag_chat?key=${info.data.description}&&rag=${info.data.extConfig.ragTag}`
      )
  }

  const handleCreateConversation = (
    content: string,
    imageUrls: string[],
    docUrls: any[]
  ) => {
    if (isLoading) return
    setIsLoading(true)

    try {
      const newConversation = createConversation(MenuPage.Chat, content)
      // 构建URL参数
      let params = new URLSearchParams()
      params.append('prompt', content)
      params.append('imageUrls', JSON.stringify(imageUrls || []))
      params.append('docUrls', JSON.stringify(docUrls || []))
      navigate(`/chat/${newConversation.conversationId}?${params.toString()}`)
    } catch (error) {
      setIsLoading(false)
    }
  }

  return (
    <BasePage title="对话" className={styles.chat}>
      <div className={styles.landingContainer}>
        <header className={styles.landingHeader}>
          <ModelSelect />
        </header>
        <div className={styles.landingContent}>
          <PlaceholderNode
            className={styles.placeholder}
            onPromptsItemClick={handlePromptClick}
          />
        </div>

        <ChatInput
          inputValue={inputValue}
          onInputChange={setInputValue}
          onSubmit={handleCreateConversation}
          isLoading={isLoading}
          isActionButton={true}
        />
      </div>
    </BasePage>
  )
}

export default ChatLandingView
